import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiBarChart2, FiCompass, FiPlay, FiSearch, FiMessageCircle, FiUsers, FiShoppingCart, FiFileText, FiPackage, FiHeadphones, FiActivity } from "react-icons/fi";
import services from "../lib/services";

const iconFor = (slug) => ({
  "market-entry-strategy": FiCompass,
  "brand-localisation": FiBarChart2,
  "performance-marketing": FiPlay,
  "seo-organic": FiSearch,
  "social-content": FiMessageCircle,
  "influencer-creator": FiUsers,
  "ecommerce-activation": FiShoppingCart,
  "pr-earned-media": FiFileText,
  "retail-distribution": FiPackage,
  "local-operations": FiHeadphones,
  "analytics-attribution": FiActivity
}[slug] || FiArrowUpRight);

const CapGrid = () => (
  <div className="cap-grid">
    {services.map((s, i) => {
      const Icon = iconFor(s.slug);
      return (
        <Link key={s.slug} to={`/services/${s.slug}`} className="cap">
          <div className="head">
            <span className="num">{String(i + 1).padStart(2, "0")} / 11</span>
            <span className="glyph"><Icon /></span>
          </div>
          <h3>{s.title}</h3>
          <p>{s.lead}</p>
          <span className="more">Read more <FiArrowUpRight /></span>
        </Link>
      );
    })}
  </div>
);

export default CapGrid;
